import {
  IPriceIncrease,
  INextPriceIncrease,
  IAddBuyPrice,
} from '../models/Price';

export const SAVE_PRICE_INCREASE = 'SAVE_PRICE_INCREASE';
export const SAVE_PRICE_INCREASE_SUCCESS = 'SAVE_PRICE_INCREASE_SUCCESS';
export const SAVE_PRICE_INCREASE_ERROR = 'SAVE_PRICE_INCREASE_ERROR';

export const FETCH_PRICE_INCREASE = 'FETCH_PRICE_INCREASE';
export const FETCH_PRICE_INCREASE_SUCCESS = 'FETCH_PRICE_INCREASE_SUCCESS';
export const FETCH_PRICE_INCREASE_ERROR = 'FETCH_PRICE_INCREASE_ERROR';

export const FETCH_NEXT_PRICE_INCREASE = 'FETCH__NEXT_PRICE_INCREASE';
export const FETCH_NEXT_PRICE_INCREASE_SUCCESS =
  'FETCH__NEXT_PRICE_INCREASE_SUCCESS';
export const FETCH_NEXT_PRICE_INCREASE_ERROR =
  'FETCH__NEXT_PRICE_INCREASE_ERROR';

export const ADD_BUY_PRICE = 'ADD_BUY_PRICE';
export const ADD_BUY_PRICE_SUCCESS = 'ADD_BUY_PRICE_SUCCESS';
export const ADD_BUY_PRICE_ERROR = 'ADD_BUY_PRICE_ERROR';

export interface SavePriceIncrease {
  type: typeof SAVE_PRICE_INCREASE;
}

export interface SavePriceIncreaseSuccess {
  type: typeof SAVE_PRICE_INCREASE_SUCCESS;
  payload: IPriceIncrease;
}

export interface SavePriceIncreaseError {
  type: typeof SAVE_PRICE_INCREASE_ERROR;
}

export interface FetchPriceIncrease {
  type: typeof FETCH_PRICE_INCREASE;
}

export interface FetchPriceIncreaseSuccess {
  type: typeof FETCH_PRICE_INCREASE_SUCCESS;
  payload: IPriceIncrease;
}

export interface FetchPriceIncreaseError {
  type: typeof FETCH_PRICE_INCREASE_ERROR;
}

export interface FetchNextPriceIncrease {
  type: typeof FETCH_NEXT_PRICE_INCREASE;
}

export interface FetchNextPriceIncreaseSuccess {
  type: typeof FETCH_NEXT_PRICE_INCREASE_SUCCESS;
  payload: INextPriceIncrease;
}

export interface FetchNextPriceIncreaseError {
  type: typeof FETCH_NEXT_PRICE_INCREASE_ERROR;
}

export interface AddBuyPrice {
  type: typeof ADD_BUY_PRICE;
}

export interface AddBuyPriceSuccess {
  type: typeof ADD_BUY_PRICE_SUCCESS;
  payload: IAddBuyPrice;
}

export interface AddBuyPriceError {
  type: typeof ADD_BUY_PRICE_ERROR;
}

export type PriceIncreaseActionTypes =
  | SavePriceIncrease
  | SavePriceIncreaseSuccess
  | SavePriceIncreaseError
  | FetchPriceIncrease
  | FetchPriceIncreaseSuccess
  | FetchPriceIncreaseError
  | FetchNextPriceIncrease
  | FetchNextPriceIncreaseSuccess
  | FetchNextPriceIncreaseError
  | AddBuyPrice
  | AddBuyPriceSuccess
  | AddBuyPriceError;
